import actionCreatorFactory from 'typescript-fsa';
const modalActionCreator = actionCreatorFactory('@@TAP/modal');
export const openModal = modalActionCreator('SHOW_MODAL');
export const closeAllModals = modalActionCreator('CLOSE_MODAL');
export const setModalTitle = modalActionCreator('SET_MODAL_TITLE');
//# sourceMappingURL=modal.actions.js.map